import { hot } from 'react-hot-loader/root';
import Component from './connections-redux';

export default hot(Component);
